import type { State, UseDocumentResult } from '@ztechapps/common.hook'
import { useObjectState, useQueryEffect } from '@ztechapps/common.hook'
import type { Order } from '@ztechapps/common.contract'
import { PaymentMethodEnum } from '@ztechapps/common.contract'
import type { PaymentOptions } from '../types'

export const usePaymentOptions = (orderDocument: UseDocumentResult<Order>): State<PaymentOptions> => {
  const [paymentOptions, setPaymentOptions] = useObjectState<PaymentOptions>({})
  useQueryEffect(() => {
    const { document } = orderDocument
    const balance = document?.paymentBalance?.balance

    setPaymentOptions({ amount: balance, remarks: '', method: PaymentMethodEnum.card })
  }, orderDocument)

  return [paymentOptions, setPaymentOptions]
}
